import { render, staticRenderFns } from "./businessUnitTaskHistoryTab.vue?vue&type=template&id=ffe01e90&scoped=true&"
import script from "./businessUnitTaskHistoryTab.vue?vue&type=script&lang=js&"
export * from "./businessUnitTaskHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitTaskHistoryTab.vue?vue&type=style&index=0&id=ffe01e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe01e90",
  null
  
)

export default component.exports